import PreLoader from "components/PreLoader/PreLoader";
import styled from "styled-components";

export const Title = styled.span`
  margin-left: 10px;
`;

export const AdditionalTitle = styled.h4`
  margin-bottom: 10px;
`;

export const AddonsForm = styled.form`
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  align-content: space-between;
`;

export const Spinner = styled(PreLoader)`
  position: absolute;
`;

